import { render, staticRenderFns } from "./PuzzleController.vue?vue&type=template&id=a765bed8&scoped=true&"
import script from "./PuzzleController.vue?vue&type=script&lang=js&"
export * from "./PuzzleController.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleController.scss?vue&type=style&index=0&id=a765bed8&prod&scoped=true&lang=scss&"
import style1 from "./PuzzleController.vue?vue&type=style&index=1&id=a765bed8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a765bed8",
  null
  
)

export default component.exports